import styled from 'styled-components';

import { flexStyles } from '../../../../common/flexStyles';

export const StyledServiceProvidingLocationDataFormSection = styled.div`
   ${flexStyles.layout(
      '12px',
      flexStyles.whole(), // location
      flexStyles.half() // medicalField,
   )}
`;

StyledServiceProvidingLocationDataFormSection.displayName = 'StyledServiceProvidingLocationDataFormSection';
